/*
offers select generic template V1
for GWP, PWP
Collects the offer from the CMS
and makes a series of RPC calls
to gather data and populate
using a mustache template
*/

var generic = generic || {};

(function ($, generic) {
  var offersSelect = {
    offerCodes: [],
    offers: {},
    productData: {},
    selectedSkus: {},
    transData: {
      offers: [],
      samples: []
    },
    options: {},
    attached: false,
    init: function (context) {
      var self = this;

      $('.offerspick', context).each(function () {
        var offercode = $(this).data('offercode');

        self.offerCodes.push(offercode);
        self.options[offercode] = {};
        self.options[offercode].container = this;
        self.options[offercode].imageType = $(this).data('image-type') || 'product';
        self.options[offercode].imageSize = $(this).data('image-size') || 'medium';
        self.selectedSkus[offercode] = [];
      });
      var params = {
        offers: self.offerCodes,
        get_products: 1,
        get_transaction: 1
      };

      self.getOffersData(params, function (response) {
        self.offers = response.getValue().offers;
        if (_.isEmpty(self.offers)) {
          return;
        }
        var offersProducts = response.getValue().offersProducts;
        var trans = response.getValue().transaction;

        if (trans) {
          self.transData.offers = trans.offerCodes;
          self.transData.samples = trans.order.samples;
        }
        $.each(self.offerCodes, function (i, offercode) {
          var offer = self.offers[offercode];

          if (!offer || offer.timing !== 'active') {
            return true;
          }
          self.options[offercode].choices = offer.benefits[0].choices;
          self.options[offercode].max_allowed = offer.benefits[0].max_allowed;
          self.options[offercode].max_to_show = offer.benefits[0].max_to_show;
          self.preSortProducts(offersProducts, offercode);
        });
      });
    },
    getOffersData: function (params, callback) {
      generic.jsonrpc.fetch({
        method: 'offers.getOffersRpcData',
        params: [params],
        onBoth: callback
      });
    },
    preSortProducts: function (data, offercode) {
      var self = this;

      if (_.isEmpty(data.skus) || !data.skus[offercode].length) {
        return;
      }

      self.productData[offercode] = [];
      var skus = [];

      $.each(data.skus[offercode], function (index, sku) {
        skus.push($.extend({}, data.products[sku.PRODUCT_ID], { skus: [sku] }));
      });
      self.productData[offercode] = _.sortBy(skus, function (o) {
        return o.PROD_RGN_NAME;
      });
      self.renderProducts(offercode);
    },
    renderProducts: function (offercode) {
      var self = this;

      // limit products displayed to max allowed
      self.productData[offercode] = self.productData[offercode].slice(
        0,
        self.options[offercode].max_to_show
      );
      self.checkCart(offercode);
      var $image = $('.js-image-select', self.options[offercode].container);
      var $select = $('.js-sku-select', self.options[offercode].container);
      var offerImage = $image.data('image');

      $.each(self.productData[offercode], function (index, product) {
        // images
        var type = self.options[offercode].imageType;

        if (product.skus.length > 1) {
          // multi-sku
          type = 'product';
        }

        var sku = product.skus[0];
        var image = '';

        // prodcat values may need to be changed by brand
        if (self.options[offercode].imageSize === 'small') {
          image = type === 'product' ? product.IMAGE_SMALL : product.skus[0].IMAGE_SMALL;
        } else if (self.options[offercode].imageSize === 'medium') {
          image = type === 'product' ? product.IMAGE_MEDIUM[0] : product.skus[0].IMAGE_MEDIUM[0];
        } else if (self.options[offercode].imageSize === 'large') {
          image = type === 'product' ? product.IMAGE_LARGE[0] : product.skus[0].IMAGE_LARGE[0];
        } else {
          image = type === 'product' ? product.IMAGE_MEDIUM[0] : product.skus[0].IMAGE_MEDIUM[0];
        }

        var $option = $('<option/>');
        var attr = {
          value: sku.SKU_BASE_ID,
          'data-image': image
        };

        // sku in cart
        if (self.selectedSkus[offercode].indexOf(sku.SKU_BASE_ID) > -1) {
          attr.selected = 'selected';
          offerImage = image;
        }
        // handle OOS
        if (!sku.isOrderable) {
          $option.addClass('oos');
        }
        $option.attr(attr).text(product.PROD_RGN_NAME);
        $select.append($option);
      });
      $select.removeClass('no-selectjs');
      if (Drupal?.behaviors?.selectBox) {
        Drupal.behaviors.selectBox.initAll();
      }
      if (offerImage) {
        self.setImageSrc(offercode, offerImage);
      }

      self.cartActions(offercode);
    },
    isOfferInCart: function (offercode) {
      return this.transData.offers.indexOf(offercode) !== -1;
    },
    checkCart: function (offercode) {
      var self = this;

      if (!self.transData.offers.length || !self.transData.samples.length) {
        return;
      }
      // is item already in cart?
      $.each(self.transData.offers, function (index, offer) {
        if (offer !== offercode) {
          return true; // continue;
        }
        $.each(self.transData.samples, function (index, sample) {
          self.selectedSkusPush(sample['sku.SKU_BASE_ID'], offercode);
        });
      });
    },
    setImageSrc: function (offercode, imageSrc) {
      $('.js-image-select', this.options[offercode].container).attr('src', imageSrc);
    },
    cartActions: function (offercode) {
      var self = this;

      self.toggleButtons(offercode);
      // add to cart
      var $select = $('.js-sku-select', self.options[offercode].container);
      var $oosMessage = $('.js-oos-message', self.options[offercode].container);
      var $addBtns = $('.js-add-offer', self.options[offercode].container);

      $select.change(function () {
        self.selectedSkus[offercode] = [];
        var $selected = $(this).find('option:selected');

        // set selected image
        self.setImageSrc(offercode, $selected.data('image'));
        // handle OOS
        if ($selected.hasClass('oos')) {
          self.removeOfferCart(offercode);
          $select.addClass('oos');
          $oosMessage.removeClass('hidden');
          self.toggleButtons(offercode);
          $addBtns.addClass('button--disabled');

          return false;
        } else {
          $select.removeClass('oos');
          $addBtns.removeClass('button--disabled');
          $oosMessage.addClass('hidden');
        }
        // add / remove offer
        var skuIds = $(this).val();

        self.selectedSkusPush(skuIds, offercode);
        self.toggleButtons(offercode);
      });

      $addBtns.once().click(function () {
        self.addOfferCart(offercode);
      });
    },
    toggleButtons: function (offercode) {
      var $continueBtn = $('.js-continue', this.options[offercode].container);
      var $skipBtn = $('.js-skip', this.options[offercode].container);
      var $checkoutContinueBtn = $('.js-checkout-continue', document);

      if (this.selectedSkus[offercode].length) {
        $continueBtn.removeClass('hidden');
        $skipBtn.addClass('hidden');
        $checkoutContinueBtn.removeClass('hidden');
      } else {
        $continueBtn.addClass('hidden');
        $checkoutContinueBtn.addClass('hidden');
        $skipBtn.removeClass('hidden');
      }
    },
    addOfferCart: function (offercode) {
      var self = this;
      // offer.apply
      var params = {
        offer_code: offercode,
        benefits: {
          ChoiceOfSkus: {
            choices: self.selectedSkus[offercode]
          }
        }
      };

      generic.jsonrpc.fetch({
        method: 'offers.apply',
        params: [params],
        onBoth: function (response) {
          var offer = response.getValue();

          if (offer && offer.inCart) {
            self.cartConfirm(offercode);
          }
        }
      });
    },
    removeOfferCart: function (offercode, callback) {
      var params = {
        offer_code: offercode
      };

      generic.jsonrpc.fetch({
        method: 'offer.removeOfferByCode',
        params: [params],
        onBoth: function () {
          if (typeof callback === 'function') {
            callback();
          }
        }
      });
    },
    cartConfirm: function () {
      var self = this;

      generic.jsonrpc.fetch({
        method: 'trans.get',
        params: [
          {
            trans_fields: ['TRANS_ID', 'totals'],
            payment_fields: [],
            order_fields: ['items', 'samples', 'offerCodes']
          }
        ],
        onSuccess: function (response) {
          var trans = response.getValue();

          if (!trans) {
            return;
          }
          self.transData.offers = trans.offerCodes;
          self.transData.samples = trans.order.samples;
          var args = {
            trans: trans,
            items: trans.order.items
          };

          // trigger event in gnav_pick_v1.js
          $(document).trigger('offerToCart.success', args);
        },
        onError: function () {}
      });
    },
    selectedSkusPush: function (skuIds, offercode) {
      var self = this;

      skuIds = _.isArray(skuIds) ? skuIds : [skuIds];
      skuIds.forEach(function (skuBaseId) {
        skuBaseId = parseInt(skuBaseId);
        if (!isNaN(skuBaseId) && self.selectedSkus[offercode].indexOf(skuBaseId) === -1) {
          self.selectedSkus[offercode].push(skuBaseId);
        }
      });
    }
  };

  Drupal.behaviors.offersSelectUkV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      offersSelect.init(context);
    }
  };
})(jQuery, generic);
